import React, { useContext, useEffect, useState, Fragment } from 'react';
import { Nav, Row, Col, Tab } from 'react-bootstrap';
import styled from 'styled-components';
import { FaShoppingCart } from 'react-icons/fa';
import { ImTree } from 'react-icons/im';
import { RiSettings5Fill } from 'react-icons/ri';
import { SiHomeassistantcommunitystore } from 'react-icons/si';
import BuyTabs from './buy-tab';
import DistributeTab from './distribute-tab';
import ProductTab from './product-tab';
import StoreTab from './store-tab';
import { HDivider } from 'components/CommonWidgets';
import { useAdminDispatch } from 'admin-app/redux/admin.store';
import { resetAllFilters as resetDashboardFilters } from 'admin-app/redux/dashboard-filter.slice';
import { resetAllFilters as resetReportingFilters } from 'admin-app/redux/reporting-filter.slice';
import { DashboardContext, DashboardProvider } from 'context/DashboardContext';

const MainCard = styled.div`
	position: relative;
	border-radius: 26px;
	margin: 1rem 0 0 1rem;
`;

const TabsCard = styled.div`
	background-color: white;
	margin: 0 auto;
	border-top-left-radius: 26px;
	border-top-right-radius: 26px;
`;

const TabColumn = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        color: black;
        font-weight: 900;
        font-size: 14pt;
    }
`;

const TabLine = styled.div`
	width: 10em;
	height: 0.5rem;
	background-color: #0278ee;
	border-top-left-radius: 11px;
	border-top-right-radius: 11px;
`;

const TabContent = styled(Tab.Content)`
    width: 100%;
    transition: all 500ms ease-in-out;
`;

const PageTitle = styled.div`
	color: white;
	font-size: 18pt;
	font-weight: 700;
	text-align: end;
`;

const Dashboard = () => {
	const [ currentTab, setCurrentTab ] = useState('buy');
	const dispatch = useAdminDispatch();

	const { changeTab } = useContext(DashboardContext);

	const onTabChange = newTab => {
		dispatch(resetDashboardFilters());
		setCurrentTab(newTab);
		changeTab(newTab);
	};

	useEffect(() => {
		dispatch(resetReportingFilters());
	}, []);

	return (
		<div>
			<Fragment>
			<Row className="mt-2">
				<PageTitle>داشبورد مدیریتی</PageTitle>
			</Row>
			<MainCard>
				<Tab.Container defaultActiveKey={currentTab} onSelect={onTabChange}>
					<TabsCard className="pt-4">
						<Nav>
							<Row className="w-100">
								<TabColumn md={3}>
									<SiHomeassistantcommunitystore size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'store'}>گزارش انبار</Nav.Link>
									</Nav.Item>
									{currentTab === 'store' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<RiSettings5Fill size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'product'}>گزارش تولید</Nav.Link>
									</Nav.Item>
									{currentTab === 'product' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<ImTree size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'distribute'}>گزارش توزیع به عشایر</Nav.Link>
									</Nav.Item>
									{currentTab === 'distribute' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<FaShoppingCart size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'buy'}>گزارش خرید</Nav.Link>
									</Nav.Item>
									{currentTab === 'buy' && <TabLine />}
								</TabColumn>
							</Row>
							<HDivider />
						</Nav>
					</TabsCard>
					<Row>
						<TabContent>
							<Tab.Pane eventKey="buy">
								<BuyTabs />
							</Tab.Pane>
							<Tab.Pane eventKey="distribute">
								<DistributeTab />
							</Tab.Pane>
							<Tab.Pane eventKey="product">
								<ProductTab />
							</Tab.Pane>
							<Tab.Pane eventKey="store">
								<StoreTab />
							</Tab.Pane>
						</TabContent>
					</Row>
				</Tab.Container>
			</MainCard>
			</Fragment>
		</div>
	);
};

export default Dashboard;
